<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-solicitudes-modificacion"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true" />
  </div>
</template>

<script>
import listadoAgGridMixin from '@/views/pagos/mixins/listado-ag-grid.mixin';
// import { cellRendererNumeroRegistro } from '@/views/pagos/utils/funciones';
import { cellRendererEstadoSolicitud, formatearFechaHoraBolivia,cellRendererNumeroRegistro, getPrograma, getProgramaModulo, getSolicitante, getRevisor } from '../../utils/funciones';

export default {
  name: 'ListadoSolicitudesModificacionCalificacion',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 70,
          maxWidth: 70,
        },
        {
          headerName: 'Programa',
          cellRenderer: (params) => getPrograma(params.data?.programa),
          valueGetter: (params) => params.data?.programa,
          field: 'programaNombre',
          minWidth: 220,
          flex: 1,
        },
        {
          headerName: 'Módulo',
          cellRenderer: (params) => getProgramaModulo(params.data?.programaModulo),
          valueGetter: (params) => params.data?.programaModulo,
          field: 'moduloNombre',
          minWidth: 220,
          // maxWidth: 180,
        },
        {
          headerName: 'Solicitante',
          cellRenderer: (params) => getSolicitante(params.data?.solicitante),
          valueGetter: (params) => params.data?.solicitante,
          field: 'solicitanteNombre',
          minWidth: 220,
          // maxWidth: 180,
        },
        {
          headerName: 'Fecha Solicitud',
          cellRenderer: (params) => formatearFechaHoraBolivia(params.data?.fechaSolicitud),
          valueGetter: (params) => params.data?.fechaSolicitud,
          minWidth: 190,
          maxWidth: 210,
        },
        {
          headerName: 'Revisor',
          cellRenderer: (params) => getRevisor(params.data?.revisandoPor),
          valueGetter: (params) => params.data?.revisandoPor,
          field: 'revisandoPorNombre',
          minWidth: 220,
          // maxWidth: 180,
        },
        {
          headerName: 'Observación',
          cellRenderer: (params) => params.data?.observaciones || 'Sin observación',
          valueGetter: (params) => params.data?.observaciones,
          field: 'observaciones',
          minWidth: 150,
        },
        {
          headerName: 'Tipo',
          field: 'tipoSolicitud',
          minWidth: 60,
        },
        {
          headerName: 'Estado',
          cellRenderer: cellRendererEstadoSolicitud,
          valueGetter: (params) => params.data?.estadoSolicitud,
          minWidth: 150,
          maxWidth: 170,
        },
      ],
    };
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-solicitudes-modificacion {
  height: calc(var(--vh, 1vh) * 100 - 15rem);
}
</style>
